import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Contributor } from "../models/contributortypes";
import "../styles/AddItemForm.css"; 
import "../styles/Contributorform.css"; 
import { fetchDropDownData } from "../utils/fetchDropDownData";
import { ContributorUtils } from "../utils/contributor/contributorUtils";

interface AddContributorFormProps {
  onSave: (contributor: Contributor) => Promise<void>;
  onCancel: () => void;
  cities: any[];
  cityResponse: any[];
  currencies: any[];
  gstStateCodes: { label: string; value: string }[];
  isProcessing?: boolean;
  isEditing?: boolean;
  editingContributor?: Contributor;
}

interface ValidationErrors {
  [key: string]: string;
}

const AddContributorForm: React.FC<AddContributorFormProps> = ({
  onSave,
  onCancel,
  // cities,
  cityResponse,
  gstStateCodes,
  isProcessing,
  isEditing,
  editingContributor,
}) => {

  const [searchTerm, setSearchTerm] = useState("");
  const { currencies, fetchCurrencies, setCurrencies, cities, setCities, fetchCities, gstCodes, setGstCodes, fetchGstCodes } = ContributorUtils();

  const [contributor, setContributor] = useState<Contributor>({
    type: "",
    taxType: "",
    gstNo: "",
    code: "",
    name: "",
    addressLine1: "",
    addressLine2: "",
    cityId: "",
    pincode: "",
    contactPerson: "",
    contactNo: "",
    chequeFavorOf: "",
    email: "",
    purchaseCurrencyId: "",
    sellingCurrencyId: "",
    panNo: "",
    posCode: "",
    status: "ACTIVE",
    gstCode: "",
    panNumber: "",
    suffixCode: "",
  });

  const [statName, setStatName] = useState<string>("");
  const [errors, setErrors] = useState<ValidationErrors>({});
  const [touched, setTouched] = useState<{ [key: string]: boolean }>({});
  const [gstFieldsError, setGstFieldsError] = useState<string>("");
  const [stateError, setStateError] = useState<string>("");
  useEffect(() => {
    fetchDropDownData({
      endpoint: "/currencymaster",
      labelKey: "name",
      valueKey: "_id",
    }).then(setCurrencies);

    // fetchDropDownData({
    //   endpoint: "/citymasters",
    //   labelKey: "cityName",
    //   valueKey: "_id",
    // }).then(setCities);

    fetchCities("");
  }, []);

  useEffect(() => {
    fetchDropDownData({
      endpoint: "/gststatecode",
      labelKey: "gstCode",
      valueKey: "gstCode",
    }).then((data) => {
      const sortedData = data.sort((a, b) =>
        a.value.localeCompare(b.value)
      );
      setGstCodes(sortedData);
    });
  },[]);

  useEffect(() => {
    console.log("City Response:", cityResponse);
    console.log("Selected City ID:", contributor.cityId);

    const selectedCity = cities.find(city => city.value === contributor.cityId)
      

    console.log("Selected City Object:", selectedCity);

    if (selectedCity) {
      console.log("State Name:", selectedCity.stateName);
      setStatName(selectedCity.stateName);
      setStateError("");
    } else {
      setStatName("");
      if (touched.cityId) {
        setStateError("State is required");
      }
    }
  }, [contributor.cityId, cityResponse, touched.cityId]);

  useEffect(() => {
    if (isEditing && editingContributor) {
      const gstNo = editingContributor.gstNo || "";
      setContributor({
        ...editingContributor,
        gstCode: gstNo.substring(0, 2),
        panNumber: gstNo.substring(2, 12),
        suffixCode: gstNo.substring(12),
      });
      const selectedCity = cities.find(city => city.value === editingContributor.cityId)
      setStatName(selectedCity?.stateName);
    } else {
      setContributor({
        type: "",
        taxType: "",
        gstNo: "",
        code: "",
        name: "",
        addressLine1: "",
        addressLine2: "",
        cityId: "",
        pincode: "",
        contactPerson: "",
        contactNo: "",
        chequeFavorOf: "",
        email: "",
        purchaseCurrencyId: "",
        sellingCurrencyId: "",
        panNo: "",
        posCode: "",
        status: "ACTIVE",
        gstCode: "",
        panNumber: "",
        suffixCode: "",
      });
    }
  }, [isEditing, editingContributor]);

  useEffect(() => {
    setContributor((prev) => ({
      ...prev,
      gstNo: `${prev.gstCode}${prev.panNumber}${prev.suffixCode}`,
    }));
  }, [contributor.gstCode, contributor.panNumber, contributor.suffixCode]);

  useEffect(() => {
    const gstCodeMissing = !contributor.gstCode;
    const panNumberMissing = !contributor.panNumber;
    const panNumberInvalid = contributor.panNumber && !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(contributor.panNumber);
    const suffixCodeMissing = !contributor.suffixCode;

    if ((touched.gstCode || touched.panNumber || touched.suffixCode || touched.gstNo) &&
      (gstCodeMissing || panNumberMissing || suffixCodeMissing)) {
      setGstFieldsError("This code is required");
    } else if ((touched.panNumber || touched.panNo) && panNumberInvalid) {
      setGstFieldsError("Invalid PAN format");
    } else {
      setGstFieldsError("");
    }
  }, [contributor.gstCode, contributor.panNumber, contributor.suffixCode, touched.gstCode, touched.panNumber, touched.suffixCode, touched.panNo, touched.gstNo]);

  const validateField = (name: string, value: string): string => {
    switch (name) {
      case "type":
        return value ? "" : "Type is required";
      case "taxType":
        return value ? "" : "Tax Type is required";
      case "code":
        return value ? "" : "Code is required";
      case "name":
        return value ? "" : "Name is required";
      case "addressLine1":
        return value ? "" : "Address Line 1 is required";
      case "addressLine2":
        return value ? "" : "Address Line 2 is required";
      case "cityId":
        return value ? "" : "City is required";
      case "pincode":
        return !value ? "Pincode is required" :
          !/^\d{6}$/.test(value) ? "Pincode must be 6 digits" : "";
      case "contactPerson":
        return value ? "" : "Contact Person is required";
      case "contactNo":
        return !value ? "Contact No is required" :
          !/^\d{10}$/.test(value) ? "Contact No must be 10 digits" : "";
      case "chequeFavorOf":
        return value ? "" : "Cheque Favor Of is required";
      case "email":
        return !value ? "Email is required" :
          !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) ? "Invalid email format" : "";
      case "purchaseCurrencyId":
        return value ? "" : "Purchase Currency is required";
      case "sellingCurrencyId":
        return value ? "" : "Selling Currency is required";
      case "panNo":
        if (!value) {
          return "PAN No is required";
        } else if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value)) {
          return "Invalid PAN format";
        }
        return "";
      // case "posCode":
      //   return value ? "" : "POS Code is required";
      case "gstNo":
        return value ? "" : "GST No is required";
      case "gstCode":
      case "panNumber":
      case "suffixCode":
        return ""; 
      default:
        return "";
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    let finalValue = value;

    if (name === "pincode") {
      if (!/^\d*$/.test(value))
         return;
      if (value.length > 6) {
        finalValue = value.slice(0, 6);
      }
    }

    if (name === "contactNo" && value.length > 10) {
      finalValue = value.slice(0, 10);
    }

    if (name === "suffixCode" || name === "panNumber" || name === "panNo") {
      finalValue = value.toUpperCase();
    }

    setContributor((prev) => {
      let updatedFields = {
        ...prev,
        [name]: finalValue,
      };

      if (name === "panNumber") {
        updatedFields["panNo"] = finalValue;
      } else if (name === "panNo") {
        updatedFields["panNumber"] = finalValue;
      }

      return updatedFields;
    });

    setTouched(prev => ({
      ...prev,
      [name]: true
    }));

    setErrors(prev => {
      const newErrors = { ...prev };

      newErrors[name] = validateField(name, finalValue);
      if (name === "panNumber") {
        newErrors["panNo"] = validateField("panNo", finalValue);
      } else if (name === "panNo") {
        newErrors["panNumber"] = validateField("panNumber", finalValue);
      }

      return newErrors;
    });
  };

  const handleSelectChange = (selectedOption: any, { name }: any) => {
    const value = selectedOption?.value || "";
    console.log(selectedOption);
    if (name === "taxType" && value === 'IMPORT') {
      setContributor((prev) => ({
        ...prev,
        taxType: value,
        panNo: "",
        gstCode:"",
        panNumber:"",
        suffixCode:"",
      }))
      setTimeout(() => {
        setGstFieldsError("");
      }, 150);      
    }
   
  
    setContributor((prev) => ({
      ...prev,
      [name]: value,
    }));

    setTouched(prev => ({
      ...prev,
      [name]: true
    }));
    setErrors(prev => ({
      ...prev,
      [name]: validateField(name, value)
    }));
  };

  const preventScroll = (e: WheelEvent) => {
    e.preventDefault();
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const { name } = e.target;
    setTouched(prev => ({
      ...prev,
      [name]: true
    }));
    setErrors(prev => ({
      ...prev,
      [name]: validateField(name, contributor[name as keyof Contributor]?.toString() || "")
    }));

    e.target.removeEventListener('wheel', preventScroll)
  };

  const validateForm = (): boolean => {
    const newErrors: ValidationErrors = {};
    let isValid = true;
    const requiredFields = [
      "type", "taxType", "code", "name", "addressLine1", "addressLine2", "cityId",
      "pincode", "contactPerson", "contactNo", "chequeFavorOf", "email",
      "purchaseCurrencyId", "sellingCurrencyId", "panNo", "posCode", "gstNo"
    ];

    requiredFields.forEach(field => {
      const value = contributor[field as keyof Contributor]?.toString() || "";
      const error = validateField(field, value);
      if(contributor.taxType === 'IMPORT' && (field === 'posCode' || field === 'panNo' ||field === 'gstNo')) {
        return;

      }
      if (error) {
        newErrors[field] = error;
        isValid = false;
      }
    });
    if(contributor.taxType==='DOMESTIC'){
    if (!contributor.gstCode || !contributor.panNumber || !contributor.suffixCode) {
      setGstFieldsError("This code is required");
      isValid = false;
    } else if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(contributor.panNumber)) {
      setGstFieldsError("Invalid PAN format");
      isValid = false;
    } else {
      setGstFieldsError("");
    }
  }else{
    setGstFieldsError("");
  }
    if (!statName) {
      setStateError("State is required");
      isValid = false;
    } else {
      setStateError("");
    }

    setErrors(newErrors);
    if (!isValid) {
      const newTouched: { [key: string]: boolean } = {};
      requiredFields.forEach(field => {
        newTouched[field] = true;
      });
      newTouched["gstCode"] = true;
      newTouched["panNumber"] = true;
      newTouched["suffixCode"] = true;
      newTouched["gstNo"] = true;
      setTouched(newTouched);
    }

    return isValid;
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }
    const gstNo = `${contributor.gstCode}${contributor.panNumber}${contributor.suffixCode}`;
    const finalContributor = {
      ...contributor,
      gstNo, 
    };

    delete finalContributor.gstCode;
    delete finalContributor.panNumber;
    delete finalContributor.suffixCode;

    onSave(finalContributor);
  };

  const sortedGstStateCodes = [...gstStateCodes].sort((a, b) => Number(a.value) - Number(b.value));

  const typeOptions = [
    { value: "CUSTOMER", label: "Customer" },
    { value: "SUPPLIER", label: "Supplier" },
    { value: "CUSTOMER&SUPPLIER", label: "Customer & Supplier" },
    { value: "SUBCONTRACTOR", label: "Subcontractor" },
  ];

  const taxTypeOptions = [
    { value: "DOMESTIC", label: "Domestic" },
    { value: "IMPORT", label: "Import" },
  ];

  const statusOptions = [
    { value: "ACTIVE", label: "ACTIVE" },
    { value: "INACTIVE", label: "INACTIVE" }
  ];

  const isImportTaxType = contributor.taxType === 'IMPORT';
  
  return (
    <>
      <div className="breadcrumb">
        <span className="breadcrumb-item" onClick={onCancel}>
          Contributor
        </span>
        <span className="breadcrumb-separator"> &gt; </span>
        <span className="breadcrumb-current">{isEditing ? "Edit Contributor" : "Add Contributor"}</span>
      </div>

      <div className="form-container">
        <form onSubmit={handleSubmit} className="add-item-form">
          <div className="form-grid">
            <div className="form-group">
              <label>Type:<span className="required">*</span></label>
              <Select
                name="type"
                options={typeOptions}
                value={typeOptions.find((o) => o.value === contributor.type)}
                onChange={handleSelectChange}
                placeholder="Select Type"
                className={touched.type && errors.type ? "error-select" : ""}
              />
              {touched.type && errors.type && <div className="error-message">{errors.type}</div>}
            </div>

            <div className="form-group">
              <label>Tax Type:<span className="required">*</span></label>
              <Select
                name="taxType"
                options={taxTypeOptions}
                value={taxTypeOptions.find((o) => o.value === contributor.taxType)}
                onChange={handleSelectChange}
                placeholder="Select Tax Type"
                className={touched.taxType && errors.taxType ? "error-select" : ""}
              />
              {touched.taxType && errors.taxType && <div className="error-message">{errors.taxType}</div>}
            </div>

       
            <div className="form-group1">
              <label>GST No:<span className="required">*</span></label>
              {gstFieldsError && <div className="error-message">{gstFieldsError}</div>}
              <div className="gst-fields">
                <Select
                  name="gstCode"
                  options={gstCodes}
                  value={gstCodes.find((o) => o.value === (contributor.gstCode)) || null}
                  onInputChange={(inputValue) => fetchGstCodes(inputValue)}
                  onChange={handleSelectChange}
                  isDisabled={isImportTaxType}
                  placeholder="GST"
                  className={`gst-select ${gstFieldsError ? "error-select" : ""} ${isImportTaxType ? "read-only-select" : ""}`}
                  classNamePrefix={`react-select ${isImportTaxType ? "read-only-select" : ""}`}
                />
                <input
                  type="text"
                  name="panNumber"
                  value={contributor.panNumber}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  maxLength={10}
                  disabled={isImportTaxType}
                  placeholder="PAN No"
                  className={`gst-input-pan ${gstFieldsError ? "error-input" : ""} ${isImportTaxType ? "read-only-input" : ""}`}
                />
                <input
                  type="text"
                  name="suffixCode"
                  value={contributor.suffixCode}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  maxLength={3}
                  disabled={isImportTaxType}
                  placeholder="Suffix"
                  className={`gst-input-suffix ${gstFieldsError ? "error-input" : ""} ${isImportTaxType ? "read-only-input" : ""}`}
                />
              </div>
            </div>

            <div className="form-group">
              <label>Generated GST No:<span className="required">*</span></label>
              <input
                type="text"
                name="gstNo"
                value={contributor.gstNo}
                readOnly
                className={`gst-display read-only-input ${touched.gstNo && errors.gstNo ? "error-input" : ""}`}
              />
              {touched.gstNo && errors.gstNo && <div className="error-message">{errors.gstNo}</div>}
            </div>

            <div className="form-group">
              <label>Code:<span className="required">*</span></label>
              <input
                type="text"
                name="code"
                value={contributor.code}
                onChange={handleChange}
                onBlur={handleBlur}
                className={touched.code && errors.code ? "error-input" : ""}
              />
              {touched.code && errors.code && <div className="error-message">{errors.code}</div>}
            </div>

            <div className="form-group">
              <label>Name:<span className="required">*</span></label>
              <input
                type="text"
                name="name"
                value={contributor.name}
                onChange={handleChange}
                onBlur={handleBlur}
                className={touched.name && errors.name ? "error-input" : ""}
              />
              {touched.name && errors.name && <div className="error-message">{errors.name}</div>}
            </div>

            <div className="form-group">
              <label>Address Line 1 :<span className="required">*</span></label>
              <input
                type="text"
                name="addressLine1"
                value={contributor.addressLine1}
                onChange={handleChange}
                onBlur={handleBlur}
                className={touched.addressLine1 && errors.addressLine1 ? "error-input" : ""}
              />
              {touched.addressLine1 && errors.addressLine1 && <div className="error-message">{errors.addressLine1}</div>}
            </div>

            <div className="form-group">
              <label>Address Line 2 :<span className="required">*</span></label>
              <input
                type="text"
                name="addressLine2"
                value={contributor.addressLine2}
                onChange={handleChange}
                onBlur={handleBlur}
                className={touched.addressLine2 && errors.addressLine2 ? "error-input" : ""}
              />
              {touched.addressLine2 && errors.addressLine2 && <div className="error-message">{errors.addressLine2}</div>}
            </div>

            <div className="form-group">
              <label>
                City :<span className="required">*</span>
              </label>
              <Select
                name="cityId"
                options={cities}
                value={cities.find((o) => o.value === contributor.cityId) || null}
                onInputChange={(inputValue) => {
                  setSearchTerm(inputValue);
                  fetchCities(inputValue);
                }}
                onChange={handleSelectChange}
                placeholder="Select City"
                className={touched.cityId && errors.cityId ? "error-select" : ""}
                classNamePrefix="react-select"
              />
              {touched.cityId && errors.cityId && <div className="error-message">{errors.cityId}</div>}
            </div>

            <div className="form-group">
              <label>State :<span className="required">*</span></label>
              <input
                type="text"
                value={cities.find((o) => o.value === contributor.cityId)?.stateName || null}
                readOnly
                className={`read-only-input ${stateError ? "error-input" : ""}`}
              />
              {stateError && <div className="error-message">{stateError}</div>}
            </div>

            <div className="form-group">
              <label>Pincode :<span className="required">*</span></label>
              <input
                type="number"
                name="pincode"
                value={contributor.pincode}
                onChange={handleChange}
                onBlur={handleBlur}
                onFocus={(e) => e.target.addEventListener('wheel', preventScroll, { passive: false })}
                // onBlur={(e) => e.target.removeEventListener('wheel', preventScroll)}
                className={touched.pincode && errors.pincode ? "error-input" : ""}
              />
              {touched.pincode && errors.pincode && <div className="error-message">{errors.pincode}</div>}
            </div>

            <div className="form-group">
              <label>Contact Person :<span className="required">*</span></label>
              <input
                type="text"
                name="contactPerson"
                value={contributor.contactPerson}
                onChange={handleChange}
                onBlur={handleBlur}
                className={touched.contactPerson && errors.contactPerson ? "error-input" : ""}
              />
              {touched.contactPerson && errors.contactPerson && <div className="error-message">{errors.contactPerson}</div>}
            </div>

            <div className="form-group">
              <label>Contact No :<span className="required">*</span></label>
              <input
                type="number"
                name="contactNo"
                value={contributor.contactNo}
                onChange={handleChange}
                onBlur={(e) => {
                  handleBlur(e);
                  e.target.removeEventListener('wheel', preventScroll);
                }}
                onFocus={(e) => {
                  e.target.addEventListener('wheel', preventScroll, { passive: false });
                }}
                className={touched.contactNo && errors.contactNo ? "error-input" : ""}
                onKeyDown={(e) => {
                  if (
                    ["Backspace", "Delete", "Tab", "Escape", "Enter", "ArrowLeft", "ArrowRight"].includes(e.key)
                  ) {
                    return;
                  }
                  if (!/^\d$/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
              {touched.contactNo && errors.contactNo && <div className="error-message">{errors.contactNo}</div>}
            </div>

            <div className="form-group">
              <label>Cheque Favor Of :<span className="required">*</span></label>
              <input
                type="text"
                name="chequeFavorOf"
                value={contributor.chequeFavorOf}
                onChange={handleChange}
                onBlur={handleBlur}
                className={touched.chequeFavorOf && errors.chequeFavorOf ? "error-input" : ""}
              />
              {touched.chequeFavorOf && errors.chequeFavorOf && <div className="error-message">{errors.chequeFavorOf}</div>}
            </div>

            <div className="form-group">
              <label>Email :<span className="required">*</span></label>
              <input
                type="email"
                name="email"
                value={contributor.email}
                onChange={handleChange}
                onBlur={handleBlur}
                className={touched.email && errors.email ? "error-input" : ""}
              />
              {touched.email && errors.email && <div className="error-message">{errors.email}</div>}
            </div>
            <div className="form-group">
              <label>
                Purchase Currency :<span className="required">*</span>
              </label>
              <Select
                name="purchaseCurrencyId"
                options={currencies}
                value={currencies.find((o) => o.value === contributor.purchaseCurrencyId) || null}
                onInputChange={(inputValue) => {
                  setSearchTerm(inputValue);
                  fetchCurrencies(inputValue);
                }}
                onChange={handleSelectChange}
                placeholder="Select Currency"
                className={touched.purchaseCurrencyId && errors.purchaseCurrencyId ? "error-select" : ""}
                classNamePrefix="react-select"
              />
              {touched.purchaseCurrencyId && errors.purchaseCurrencyId && (
                <div className="error-message">{errors.purchaseCurrencyId}</div>
              )}
            </div>
            <div className="form-group">
              <label>
                Selling Currency :<span className="required">*</span>
              </label>
              <Select
                name="sellingCurrencyId"
                options={currencies}
                value={currencies.find((o) => o.value === contributor.sellingCurrencyId) || null}
                onInputChange={(inputValue) => {
                  setSearchTerm(inputValue);
                  fetchCurrencies(inputValue);
                }}
                onChange={handleSelectChange}
                placeholder="Select Currency"
                className={touched.sellingCurrencyId && errors.sellingCurrencyId ? "error-select" : ""}
                classNamePrefix="react-select"
              />
              {touched.sellingCurrencyId && errors.sellingCurrencyId && (
                <div className="error-message">{errors.sellingCurrencyId}</div>
              )}
            </div>

            <div className="form-group">
              <label>PAN No :<span className="required">*</span></label>
              <input
                type="text"
                name="panNo"
                value={contributor.panNo}
                onChange={handleChange}
                onBlur={handleBlur}
                readOnly={isImportTaxType}
                className={`${touched.panNo && errors.panNo ? "error-input" : ""} ${isImportTaxType ? "read-only-input" : ""}`}
                maxLength={10}
              />
              {touched.panNo && errors.panNo && <div className="error-message">{errors.panNo}</div>}
            </div>

            <div className="form-group">
              <label>POS Code :<span className="required">*</span></label>
              <input
                type="text"
                name="posCode"
                value={contributor.gstCode}
                // onChange={handleChange}
                // onBlur={handleBlur}
                readOnly
                className={touched.posCode && errors.posCode ? "error-input" : ""}
              />
              {touched.posCode && errors.posCode && <div className="error-message">{errors.posCode}</div>}
            </div>

            {isEditing &&
              <div className="form-group">
                <label>Status :<span className="required">*</span></label>
                <Select
                  name="status"
                  options={statusOptions}
                  value={statusOptions.find((o) => o.value === contributor.status)}
                  onChange={handleSelectChange}
                />
              </div>}
          </div>

          <div className="button-container">
            <button type="button" className="button cancel-button" onClick={onCancel}>Cancel</button>
            <button type="submit" className="button save-button" disabled={isProcessing}>{isProcessing ? "Saving..." : isEditing ? "Update Contributor" : "Add Contributor"}</button>
          </div>
        </form>
      </div>
    </>
  );
};

export default AddContributorForm;
